import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';

// * hợp đồng lao động
const ContractLaborManagement = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborManagement')
);
const ContractLaborFromFileWizard = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborFromFileWizard')
);
const ContractLaborFromTemplateWizard = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborFromTemplateWizard')
);
const ContractLaborConversionWizard = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborConversionWizard')
);
const ContractLaborFromProviderWizard = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborFromProviderWizard')
);
const ContractLaborAppendixWizard = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborAppendixWizard')
);
const ContractLaborManagementGroup = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborManagementGroup')
);
const ContractLaborManagementPosition = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/pdf-contract/ContractLaborManagementPosition')
);
const ContractLaborManagementViewEnd = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/contract-view/ContractLaborManagementViewEnd')
);
const ContractLaborManagementEdit = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/ContractLaborManagementEdit')
);
const ContractLaborManagementView = lazy(
    () => import('features/contract-labor/contract-labor-management/pages/contract-view/ContractLaborManagementView')
);

const ContractLaborManagementConfirm = lazy(
    () => import('features/contract-labor/contract-labor-management-confirm/pages/ContractLaborManagementConfirm')
);
const ContractLaborManagementConfirmView = lazy(
    () => import('features/contract-labor/contract-labor-management-confirm/pages/ContractLaborManagementConfirmView')
);

const ContractLaborManagementConfirmed = lazy(() =>
    import('features/contract-labor/contract-labor-management-confirmed/pages/ContractLaborManagementConfirmed')
);
const ContractLaborManagementConfirmedView = lazy(() =>
    import('features/contract-labor/contract-labor-management-confirmed/pages/ContractLaborManagementConfirmedView')
);

const ContractLaborManagementRefuse = lazy(() =>
    import('features/contract-labor/contract-labor-management-refuse/pages/ContractLaborManagementRefuse')
);
const ContractLaborManagementRefuseView = lazy(() =>
    import('features/contract-labor/contract-labor-management-refuse/pages/ContractLaborManagementRefuseView')
);

const ContractLaborRouter = [
    // Luồng "Chuyển đổi hợp đồng" — chọn mẫu, upload nguồn, OCR.
    {
        path: routerMain.CONTRACT_CONVERSION,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    // Ba bước đầu của conversion dùng cùng wizard, mỗi bước có URL riêng.
    {
        path: `${routerMain.CONTRACT_CONVERSION}/chon-mau`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    {
        path: `${routerMain.CONTRACT_CONVERSION}/tai-file-nguon`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    {
        path: `${routerMain.CONTRACT_CONVERSION}${routerPathMain.DECLARE}`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    {
        path: `${routerMain.CONTRACT_CONVERSION}${routerPathMain.POSITION}`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    // URL gốc có UUID được dùng khi mở lại bản nháp; wizard tự chọn bước đã lưu.
    {
        path: `${routerMain.CONTRACT_CONVERSION}/:uuid`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    // Các bước xử lý conversion dùng chính wizard để giữ activeIndex 0–4.
    {
        path: `${routerMain.CONTRACT_CONVERSION}/:step/:uuid`,
        exact: true,
        component: ContractLaborConversionWizard,
    },
    // Luồng Chuyển đổi từ nhà cung cấp khác (BNV 3 bước)
    {
        path: routerMain.CONTRACT_CONVERSION_OTHER_PROVIDER,
        exact: false,
        component: ContractLaborFromProviderWizard,
    },
    // * hợp đồng lao động
    {
        path: routerMain.CONTRACT_LABOR,
        exact: true,
        component: ContractLaborManagement,
    },
    {
        path: routerMain.CONTRACT_LABOR_ELECTRONIC,
        exact: true,
        component: ContractLaborManagement,
    },
    {
        path: routerMain.CONTRACT_LABOR_LEGACY,
        exact: true,
        component: ContractLaborManagement,
    },
    // Luồng "Chỉnh sửa từ mẫu" — Route riêng biệt
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT_FROM_TEMPLATE}`,
        exact: false,
        component: ContractLaborFromTemplateWizard,
    },
    // Luồng "Chỉnh sửa từ file" — Route riêng biệt
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT_FROM_FILE}`,
        exact: false,
        component: ContractLaborFromFileWizard,
    },
    // Luồng "Tạo từ file" — Nested Routing (1 route duy nhất, exact: false)
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.ADD_FROM_FILE}`,
        exact: false,
        component: ContractLaborFromFileWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.ADD_FROM_TEMPLATE}`,
        exact: false,
        component: ContractLaborFromTemplateWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.ADD_APPENDIX}`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.ADD_EXTEND}`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.ADD_TERMINATE}`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    // Route edit nháp phụ lục / gia hạn / chấm dứt
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT_APPENDIX}/:uuid`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT_EXTEND}/:uuid`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT_TERMINATE}/:uuid`,
        exact: false,
        component: ContractLaborAppendixWizard,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: ContractLaborManagementEdit,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractLaborManagementGroup,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractLaborManagementPosition,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.EDIT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractLaborManagementViewEnd,
    },
    {
        path: `${routerMain.CONTRACT_LABOR}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractLaborManagementView,
    },
    {
        path: routerMain.CONTRACT_LABOR_CONFIRM,
        exact: true,
        component: ContractLaborManagementConfirm,
    },
    {
        path: `${routerMain.CONTRACT_LABOR_CONFIRM}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractLaborManagementConfirmView,
    },

    {
        path: routerMain.CONTRACT_LABOR_CONFIRMED,
        exact: true,
        component: ContractLaborManagementConfirmed,
    },
    {
        path: `${routerMain.CONTRACT_LABOR_CONFIRMED}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractLaborManagementConfirmedView,
    },
    {
        path: routerMain.CONTRACT_LABOR_REFUSE,
        exact: true,
        component: ContractLaborManagementRefuse,
    },
    {
        path: `${routerMain.CONTRACT_LABOR_REFUSE}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractLaborManagementRefuseView,
    },

];
export default ContractLaborRouter;
